import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Music, Mic, Calendar, Mail, User, LogOut } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [location]); // Re-check on nav change

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    window.location.href = '/';
  };

  const navLinks = [
    { name: 'Home', path: '/', icon: <Music className="w-4 h-4" /> },
    { name: 'Booking', path: '/booking', icon: <Calendar className="w-4 h-4" /> },
    { name: 'Beats', path: '/beats', icon: <Mic className="w-4 h-4" /> },
    { name: 'Contact', path: '/contact', icon: <Mail className="w-4 h-4" /> },
  ];

  return (
    <nav className="fixed w-full z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
             <div className="w-8 h-8 bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg flex items-center justify-center">
                <span className="font-bold text-white text-lg">J</span>
             </div>
             <span className="font-bold text-xl tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
               Jeanjo Unis
             </span>
          </Link>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-purple-400 bg-white/5'
                      : 'text-gray-300 hover:text-white hover:bg-white/5'
                  }`}
                >
                  {link.icon}
                  {link.name}
                </Link>
              ))}

              {user ? (
                 <div className="flex items-center gap-4 ml-4 pl-4 border-l border-white/10">
                    <Link to="/dashboard" className="flex items-center gap-2 text-sm font-bold text-white hover:text-purple-400">
                       <User className="w-4 h-4" /> Espace Artiste
                    </Link>
                    <button onClick={handleLogout} className="text-gray-400 hover:text-white">
                       <LogOut className="w-4 h-4" />
                    </button>
                 </div>
              ) : (
                 <Link to="/login" className="ml-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-full text-sm font-bold transition-colors">
                    Connexion
                 </Link>
              )}
            </div>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-md text-gray-400 hover:text-white hover:bg-white/5"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-black/95 border-b border-white/10">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`flex items-center gap-3 px-3 py-4 rounded-md text-base font-medium ${
                  location.pathname === link.path
                    ? 'text-purple-400 bg-white/5'
                    : 'text-gray-300 hover:text-white hover:bg-white/5'
                }`}
              >
                {link.icon}
                {link.name}
              </Link>
            ))}
             {user ? (
                 <>
                    <Link to="/dashboard" onClick={() => setIsOpen(false)} className="flex items-center gap-3 px-3 py-4 rounded-md text-base font-medium text-white hover:bg-white/5">
                        <User className="w-4 h-4" /> Espace Artiste
                    </Link>
                    <button onClick={() => {handleLogout(); setIsOpen(false);}} className="w-full text-left flex items-center gap-3 px-3 py-4 rounded-md text-base font-medium text-red-400 hover:bg-white/5">
                        <LogOut className="w-4 h-4" /> Déconnexion
                    </button>
                 </>
              ) : (
                 <Link to="/login" onClick={() => setIsOpen(false)} className="flex items-center gap-3 px-3 py-4 rounded-md text-base font-medium text-purple-400 hover:bg-white/5">
                    Connexion
                 </Link>
              )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
